import React, { useEffect } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import useChatNavigation from "../../../../../Common/useChatNavigation";
import {
  Commas,
  getDateFormate,
} from "../../../../../Common/AllDateTimeReleventFormate";
import { useNavigate } from "react-router-dom";
import { getBxpTogether5 } from "../../../../../../redux/ots/action";
import { getRentalStatusText, getSaleStatusText } from "../../../../../Common/Status/Bxpstatus";
import ActivePackangeService from "./ActivePackangeService";
import RentalDetailsLabel from "../../../../../Common/Label/RentalDetailsLabel";
import ProfilePic from "../../../../../../assests/imgs/Profileplaceholder.svg";
import ImageWithFallback from "../../../../../../common/ImageWithFallback";
import { decodeHtml } from "../../../../../../assests/extention/commonfunction";

export default function PendingRequests({ postcounts }) {
  const dispatch = useDispatch();
  const { letChat } = useChatNavigation();
  const navigate = useNavigate();
  const togeter5 = useSelector(
    ({ ots: { bxptogetherlist5 } }) => bxptogetherlist5
  );

  const laung = localStorage.getItem("laung") ?? "en";

  useEffect(() => {
    dispatch(getBxpTogether5(5));
  }, []);

  let lastDisplayedDate = null;

  return (
    <>
      <div className="posted-project umbrellaproject-sec pending-req">
        <>
          <ActivePackangeService
            list={togeter5?.bxp}
            count={postcounts?.bxp_active || 0}
          />
        </>
        <>
          <h4>Buy & Sell with Market (BSM) requests ({postcounts?.sale_active || 0})</h4>
          {Array.isArray(togeter5?.sale) && togeter5?.sale?.length > 0 ? (
            <>
              {togeter5?.sale.map((item, index) => {
                 const currentDate = item.created_on.split(' ')[0];
                 const shouldDisplayDate = currentDate !== lastDisplayedDate;
                 lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && <h6 className="date-name">
                      {getDateFormate(item.created_on)}
                    </h6>}
                    <div className="pending-img">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                            <div>
                              <h5>{decodeHtml(item?.title)}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image :ProfilePic} alt="" />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Seller" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {decodeHtml(item?.first_name)} {decodeHtml(item?.last_name)}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <p className="accepted">
                              {getSaleStatusText(item?.status)}
                            </p>
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button
                              className="btn-img"
                              onClick={() => {
                                navigate(
                                  `/${laung}/dashboard/myorders/productforsaledetails/${item?.id}`
                                );
                              }}
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-color-icon.svg`}
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <>
          <h4>Turn Assets to Income (TAI) requests ({postcounts?.rental_active || 0})</h4>
          {Array.isArray(togeter5?.rental) && togeter5?.rental?.length > 0 ? (
            <>
              {togeter5?.rental.map((item, index) => {
                 const currentDate = item.created_on.split(' ')[0];
                 const shouldDisplayDate = currentDate !== lastDisplayedDate;
                 lastDisplayedDate = currentDate;
                return(
                <div className="pending-row">
                 {shouldDisplayDate && <h6 className="date-name">
                    {getDateFormate(item.created_on)}
                  </h6>}
                  <div className="pending-img">
                    <div className="row align-items-center">
                      <div className="col-md-5">
                        <div className="pending-left">
                          <ImageWithFallback url={Array.isArray(item?.files) && item?.files[0]?.file} />
                          <div>
                            <h5>{decodeHtml(item?.title)}</h5>
                            <h3>
                              ${" "}
                              {Commas(
                                item?.total_price
                                  ? item?.total_price
                                  : item?.price
                              )}
                            </h3>
                            <RentalDetailsLabel item={item} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="pending-center">
                          <img src={item?.profile_image ? item?.profile_image :ProfilePic} alt="" />
                          <div>
                            <p>
                              {item?.is_mine == 0 ? "Owner" : "Ordered by"}
                              <p>
                                {" "}
                                <img
                                  src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                  alt=""
                                />{" "}
                                {item?.rating || 0} ({item?.reviews || 0}{" "}
                                reviews)
                              </p>
                            </p>
                            <h5>
                               {decodeHtml(item?.first_name)} {decodeHtml(item?.last_name)}
                             </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="pending-right">
                          <p className="accepted">
                            {getRentalStatusText(item?.status)}
                          </p>
                          <button
                            onClick={() => letChat(item)}
                            className="buttons border-button"
                          >
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                              alt=""
                            />
                          </button>
                          <button
                            className="btn-img"
                            onClick={() => {
                              navigate(
                                `/${laung}/dashboard/myorders/rentalproductsdetails/${item?.id}`
                              );
                            }}
                          >
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/common/right-color-icon.svg`}
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )})}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
      </div>
    </>
  );
}
